import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { reviewKeys } from '../claim-submission.constant';
import { updateClaimContext } from '../claim-submission.helper';
import { ClaimSubmission } from '../claim-submission.model';
import { ClaimSubmissionService } from '../claim-submission.service';
import { SubmittedClaimDetails } from '../submittedClaim';
import { keysThatUseClaimItemsInformation } from './claim-submission-review.constants';

@Component({
  selector: 'lib-claim-submission-review',
  templateUrl: './claim-submission-review.component.html',
  styleUrls: ['./claim-submission-review.component.scss'],
})
export class ClaimSubmissionReviewComponent implements OnInit {
  @Input() config: ClaimSubmission;
  @Input() totalClaimLineCharges: number;
  @Input() isEditable = true;
  @Input() claimId: string;
  @Input() submittedClaimContext: SubmittedClaimDetails;
  @Output() certificationFormValueChanged =
    new EventEmitter<UntypedFormGroup>();
  @Output() editIconClickedEmitter: EventEmitter<string> =
    new EventEmitter<string>();

  context: object;
  certificationForm: UntypedFormGroup = new UntypedFormGroup({});
  supportingDocumentationUploadedFiles = [];
  summaryPageDocumentUploadedFiles = [];
  documentUploadUrl: string;
  public reviewList = [];

  constructor(public claimSubmissionService: ClaimSubmissionService) {}

  ngOnInit(): void {
    this.documentUploadUrl =
      this.config?.forms?.supportingDocumentation?.documentUploadUrl;
    this.reviewList =
      this.config?.reviews &&
      Object.entries(this.config?.reviews).map(([key, value]) => ({
        key,
        value,
      }));

    this.updateContext();

    this.certificationForm.valueChanges.subscribe(() => {
      this.certificationFormValueChanged.emit(this.certificationForm);
    });
  }

  public getContext(key: string): object {
    if (
      key === reviewKeys.patientInformation &&
      this.claimSubmissionService.selectedPatient &&
      !this.claimId
    ) {
      const patientNameIndex = 1;

      this.context[key].patientName =
        this.claimSubmissionService.selectedPatient[patientNameIndex];
    }

    return this.context[key] ? this.context[key] : {};
  }

  public useThatUseClaimItemsInformation(key: string): boolean {
    return keysThatUseClaimItemsInformation.includes(key);
  }

  public editIconClickedValue(itemKey: string) {
    this.editIconClickedEmitter.emit(itemKey);
  }

  private updateContext(): void {
    if (!this.isEditable) {
      this.getSubmittedClaimDetail(this.submittedClaimContext);
    } else if (this.claimSubmissionService.claimSubmitFormData?.value) {
      this.context = this.claimSubmissionService.claimSubmitFormData.value;
      this.supportingDocumentationUploadedFiles =
        this.claimSubmissionService.uploadedFiles;
    }
  }

  private getSubmittedClaimDetail(
    submittedClaimContext?: SubmittedClaimDetails,
  ): void {
    if (submittedClaimContext) {
      this.setContext(submittedClaimContext);
    } else {
      const claimSubmissionUrl = `${this.config.claimSubmissionUrl}${this.claimId}`;

      this.claimSubmissionService
        .getClaimSubmissionDetailById(claimSubmissionUrl)
        .subscribe((data: SubmittedClaimDetails) => {
          this.setContext(data);
        });
    }
  }

  private setContext(contextData: SubmittedClaimDetails): void {
    this.context = this.reviewList.reduce(
      (reviewItems, item) => ({
        ...reviewItems,
        [item.key]: updateClaimContext(item.key, contextData),
      }),
      {},
    );
    this.summaryPageDocumentUploadedFiles =
      contextData.claimsubmissiondocument.length > 0
        ? contextData.claimsubmissiondocument
        : [];
  }
}
